import React from "react";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

interface Props extends MultiPickerListProps<server.dto.ArtistSmall> {
  securityScope: server.dto.ArtistSecurityScopes;
  hideActiveFilter: boolean;
  webform?: server.dto.WebformFilterInstruction;
}

const MultiArtistList = (props: Props) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListArtistInstruction>({
    page: 1,
    perPage: 20,
    artistSecurityScope: props.securityScope,
    webform: props.webform,
    onlyFavorite: false,
    keyword: undefined,
    profile: "onlyActive",
  });

  const setFilter = (profile: server.dto.IsArtistTypeFilterOptions) => { setInstruction(instr => ({ ...instr, profile, page: 1 })); };

  const setOnlyFavorite = (onlyFavorite: boolean) => { setInstruction(instr => ({ ...instr, onlyFavorite, page: 1 })); };

  const isExternalUser = site.currentEnvironment.type === "external";

  return <>
    <MultiPickerListWithSelectedItems
      instruction={instruction}
      onInstructionChange={i => setInstruction(i)}
      queryKey="artistpickerlist"
      api={window.CoreApi.Artist.PaginatedSmall}

      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={artist => artist.artistId}
      renderListItem={artist => <div>{artist.name}</div>}
      hideKeywordFilter={isExternalUser}
      filter1={(props.hideActiveFilter || isExternalUser) ? undefined : {
        leftButton: {
          type: "primary",
          isActive: instruction.profile === "onlyActive",
          label: RESX.SoUser.Active,
          onClick: () => { setFilter("onlyActive"); }
        },
        rightButton: {
          type: "primary",
          isActive: instruction.profile === "onlyNoLongerActive",
          label: RESX.SoUser.Deactivated,
          onClick: () => { setFilter("onlyNoLongerActive"); }
        }
      }}
      otherFilters={isExternalUser ? undefined : <Checkbox label={RESX.GeneralLabels.OnlyFavorites} checked={instruction.onlyFavorite} onChange={(_, checked) => setOnlyFavorite(checked)} />}

      onChange={props.onChange}
      getLabel={(artist) => <div>{artist.name}</div>}
      value={props.value}
    />
  </>;
};

export default MultiArtistList;